import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { CDN_URL, WEBSITE_PATH } from '@karma/utils/constants/env';
import { useTranslation } from 'react-i18next';

const MetaLayout = ({ children, custom, description, image, siteName, title, type, url }) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  return (
    <>
      <Helmet>
        {custom}

        <title>{t(title)}</title>
        <meta name="description" content={description} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content={image} />
        <meta property="og:site_name" content={siteName} />
        <meta property="og:title" content={t(title)} />
        <meta property="og:type" content={type} />
        <meta property="og:url" content={`${WEBSITE_PATH}${url ?? pathname}`} />
      </Helmet>

      {children}
    </>
  );
};

MetaLayout.propTypes = {
  children: PropTypes.node.isRequired,
  custom: PropTypes.arrayOf(PropTypes.node),
  description: PropTypes.string,
  image: PropTypes.string,
  siteName: PropTypes.string,
  title: PropTypes.string.isRequired,
  type: PropTypes.string,
  url: PropTypes.string,
};

MetaLayout.defaultProps = {
  custom: [],
  description:
    'Shop Smarter With Karma – Find And Apply Promo Codes & Cashback Automatically At Checkout. Add Karma To Your Browser & Discover How Much Money You Could Be Saving Today. Get Automatic Coupon Codes & Earn Cashback When You Shop at Your Favourite Store.',
  image: `${CDN_URL}/images/landings/og_v1.png`,
  siteName: 'Karma',
  type: 'website',
  url: null,
};

export default MetaLayout;
